import AppConstants from '../config/app.constants';

let ServiceChecklistService = function ($http, $q) {

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/service-checklist`, {
                data
            })
            .then((res) => {
                return res.data
            })
    }

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/service-checklist`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }


    let updateServiceChecklist = (data) => {
        return $http
            .post(AppConstants.api + `/service-checklist/update-service-checklist`, data)
            .then((res) => {
                return res.data
            })
    }


    return {
        create,
        all,
        updateServiceChecklist,
    }
}

ServiceChecklistService.$inject = ["$http", "$q"];

export default ServiceChecklistService;


// WEBPACK FOOTER //
// ./client/app/services/service-checklist.service.js